import { render, staticRenderFns } from "./IrrMapComponent.vue?vue&type=template&id=1a4df038"
import script from "./IrrMapComponent.vue?vue&type=script&lang=js"
export * from "./IrrMapComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports